import API from "@/utils/api";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    authenticated: false,
    isLoading: false,
    email: null,
    password: null,
    requisites: null,
    client_lang: null,
    is_email_confirmed: null,
    savingInProgress: false,
    isSendingEmailConfirmationCode: false, //код подтверждения e-mail отправляется
    isSentEmailConfirmationCode: false, //код подтверждения e-mail отправлен
    isCheckingEmailConfirmationCode: false,
    isCheckedSuccessfullyConfirmationCode: false,
  },
  getters: {
    getField, //vuex-map-fields
    authenticated(state) {
      return state.authenticated;
    },
  },
  mutations: {
    updateField, //vuex-map-fields
    setAuthenticated: (state, payload) => {
      state.authenticated = payload;
      state.password = null;
    },
  },
  actions: {
    async logout({ commit, state, dispatch }) {
      return await API.get("/logout")
        .then((response) => {
          commit(
            "setAuthenticated",
            response.data && response.data.authenticated
          );
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async check({ commit, state, dispatch }) {
      return await API.get("/authenticated")
        .then((response) => {
          commit(
            "setAuthenticated",
              response.data && response.data.data && response.data.data.authenticated === true
          );
          updateField(state, { path: "requisites", value: response.data.data.requisites });
          updateField(state, { path: "client_lang", value: response.data.data.client_lang });
          updateField(state, { path: "is_email_confirmed", value: response.data.data.is_email_confirmed});
          return (
              response.data && response.data.data && response.data.data.authenticated === true
          );
        })
        .catch((error) => {
          //dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async sendEmailConfirmationCode({ commit, state, dispatch }) {
      updateField(state, { path: "isSendingEmailConfirmationCode", value: true });
      updateField(state, { path: "isSentEmailConfirmationCode", value: false });
      return await API.post("/send-confirmation-code")
        .then((response) => {
          if(response.data.status==='success'){
            updateField(state, { path: "isSentEmailConfirmationCode", value: true });
          } else {
            throw new Error('Unknown error!')
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(()=>{
          updateField(state, { path: "isSendingEmailConfirmationCode", value: false });
        })
    },
    async checkEmailConfirmationCode({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isCheckingEmailConfirmationCode", value: true });
      return await API.post("/check-confirmation-code", payload)
        .then((response) => {
          if(response.data.status==='success'){
            updateField(state, { path: "isCheckedSuccessfullyConfirmationCode", value: true });
            updateField(state, { path: "is_email_confirmed", value: true });
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(()=>{
          updateField(state, { path: "isCheckingEmailConfirmationCode", value: false });
        })
    },
    async login({ commit, state, dispatch }) {
      updateField(state, { path: "isLoading", value: true });
      return await API.post("/login", {
        email: state.email,
        password: state.password,
      })
        .then((response) => {
          updateField(state, { path: "isLoading", value: false });
          commit("setAuthenticated", response.data.status === "success");
        })
        .catch((error) => {
          updateField(state, { path: "isLoading", value: false });
          commit("setAuthenticated", false);
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async login_as({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isLoading", value: true });
      return await API.post("/login_as", payload)
        .then((response) => {
          updateField(state, { path: "isLoading", value: false });
          commit("setAuthenticated", response.data.status === "success");
        })
        .catch((error) => {
          updateField(state, { path: "isLoading", value: false });
          commit("setAuthenticated", false);
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async updateRequisites({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await API.put("/update_requisites", payload)
        .then((response) => {
          if(response.data.data){
            updateField(state, { path: "requisites", value: response.data.data });
            return true;
          }
        })
        .catch((error) => {
          updateField(state, { path: "savingInProgress", value: false });
          dispatch("common/showError", { error: error }, { root: true });
          return false;
        });
    },
    async register({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await API.post("/register", payload)
        .then((response) => {
          if(parseInt(response.status) === 201){
            this._vm.$inform(i18n.t("common.success_register"));
            return true;
          }
        })
        .catch((error) => {
          updateField(state, { path: "savingInProgress", value: false });
          dispatch("common/showError", { error: error }, { root: true });
          return false;
        });
    },
    async passwordRecovery({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await API.post("/password-recovery", payload)
        .then((response) => {
          if(parseInt(response.status) === 204){
            return true;
          }
        })
        .catch((error) => {
          updateField(state, { path: "savingInProgress", value: false });
          dispatch("common/showError", { error: error }, { root: true });
          return false;
        });
    },
  },
};
